import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { analyticsAPI } from '@services/index';

const initialState = {
  dashboardMetrics: null,
  reports: [],
  loading: false,
  error: null,
};

export const fetchDashboardMetrics = createAsyncThunk(
  'analytics/fetchDashboard',
  async (params = undefined, { rejectWithValue }) => {
    try {
      const metrics = await analyticsAPI.getDashboardMetrics(params);
      return metrics;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard metrics');
    }
  }
);

export const generateReport = createAsyncThunk(
  'analytics/generateReport',
  async (data, { rejectWithValue }) => {
    try {
      const report = await analyticsAPI.generateReport(data);
      return report;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to generate report');
    }
  }
);

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardMetrics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchDashboardMetrics.fulfilled,
        (state, action) => {
          state.loading = false;
          state.dashboardMetrics = action.payload;
        }
      )
      .addCase(fetchDashboardMetrics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(generateReport.fulfilled, (state, action) => {
        state.reports.unshift(action.payload);
      });
  },
});

export const { clearError } = analyticsSlice.actions;
export default analyticsSlice.reducer;
